import configs from 'config';
import API_CONSTANT from 'constants/apiConstant';
import MESSAGE_CONSTANT from 'constants/msgConstant';
import { toast } from 'react-toastify';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerValidateVpaApiCallSuccess } from 'redux/actions';
import { TRIGGER_VALIDATE_VPA_API_CALL } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { ChangeHistory, CleverTapEventV2, nativeHandler } from 'utils';

function* triggerValidateVpaApiCall(actions) {
	const { data, callback } = actions;
	const INTENT = data['vpa'];
	yield put(triggerValidateVpaApiCallSuccess());
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.PAYMENT_V3,
		url: API_CONSTANT.URL.VALIDATE_VPA + API_CONSTANT.QUERY_PARAMS.INTENT + encodeURIComponent(INTENT),
		// url:
		// 	API_CONSTANT.URL.VALIDATE_VPA +
		// 	API_CONSTANT.QUERY_PARAMS.INTENT +
		// 	'upi%3A%2F%2Fpay%3Fpa%3DBHARATPE09910785523%40yesbankltd%26cu%3DINR',
		method: 'GET',
	});

	CleverTapEventV2.send('validate_vpa_version', {
		screen: 'QR_SCAN',
		action: 'clicked',
		pathTType: API_CONSTANT.URL_TYPE.PAYMENT_V3,
		url:
			configs[API_CONSTANT.URL_TYPE.PAYMENT_V3] +
			API_CONSTANT.URL.VALIDATE_VPA +
			API_CONSTANT.QUERY_PARAMS.INTENT +
			encodeURIComponent(INTENT),
	});

	if (api && api.data) {
		const apiData = api.data;
		if (apiData) {
			if (apiData?.errorType?.length > 0) {
				callback && callback(apiData);
				return;
			}
			if (!apiData?.bpMerchant) {
				callback && callback(apiData);
			} else {
				localStorage.removeItem('loan-amount');
				ChangeHistory(
					`push`,
					`/${store.getState().homeDetails?.accountType?.toLowerCase()?.replace('_', '-')}/amount-insertion`,
				);
			}
			apiData['intent'] = INTENT;
			yield put(triggerValidateVpaApiCallSuccess(apiData));
		}
	} else {
		if (api.status !== 200) {
			toast.error(api.data.message || MESSAGE_CONSTANT.SOMETHING_WRONG);
		}
		nativeHandler.removeLoader();
	}
}

export default function* triggerValidateVpaApiCallSaga() {
	yield takeEvery(TRIGGER_VALIDATE_VPA_API_CALL, triggerValidateVpaApiCall);
}
